/**
 * Reading the first sheet of an XLSX file in the browser.
 *
 * Kept apart and untested on purpose (see AGENTS.md): read-excel-file is ESM-only, so the pure
 * conversion lives in statement.ts (`xlsxCellsToTable`) and this file only does the IO.
 */
import { readSheet } from "read-excel-file/browser";
import { xlsxCellsToTable } from "./statement";

export async function readXlsxTable(file: File): Promise<string[][]> {
  return xlsxCellsToTable((await readSheet(file)) as unknown[][]);
}
